import store from '@/state/store'

const menuList = [
  {
    title: 'Riwayat Pengiriman',
    description:
      'Menampilkan pencapaian pengiriman yang telah dilakukan oleh Driver dalam periode waktu yang dipilih',
    routeName: 'Report Delivery History',
  },
  {
    title: 'Riwayat Muatan',
    description: 'Menampilkan riwayat muatan dari pengiriman hingga penugasan',
    routeName: 'Report Delivery Load',
  },
  {
    title: 'Target vs Aktual Pengiriman',
    description:
      'Menampilkan hasil ketepatan waktu pengiriman berdasarkan waktu target dan waktu aktual.',
    routeName: 'Report Delivery Plan vs Actual',
  },
  {
    title: 'Biaya Pengeluaran',
    description: 'Menampilkan riwayat biaya pengeluaran',
    routeName: 'Report Expenses',
    hasModal: true,
    isShown:
      store.getters['identity/hasAccessAll']([
        'financial-record:create',
        'financial-record:read',
        'financial-record:update',
        'financial-record:delete',
      ]),
    property: 'costManagement',
  },
  {
    key: 'fleetUtilization',
    title: 'Utilisasi Kendaraan',
    description: 'Menampilkan riwayat biaya pengeluaran',
    routeName: 'Report Fleet Utilization',
    hasModal: true,
    isShown: store.getters['identity/hasAccessAll'](['a11a-custom-report-mti:read', 'tms:read']),
    property: 'fleetUtilization',
  },
]

export default menuList
